import { CHAT_UPLOAD_EXTENSIONS, CHAT_UPLOAD_MEDIA_TYPES, isChatUploadMediaType } from "@bliks-io/contracts";
/** The picker filter every chat surface passes to `AiChatAttachButton`. */ export const CHAT_UPLOAD_ACCEPT = CHAT_UPLOAD_MEDIA_TYPES.join(",");
/**
 * Extensions the browser's own type is allowed to be missing for. `.jpeg` is
 * here and absent from `CHAT_UPLOAD_EXTENSIONS` on purpose: that mapping is what
 * a server-minted key is written with, this one is what a user's file may be
 * called.
 */ const MEDIA_TYPE_BY_EXTENSION = new Map([
    ...Object.entries(CHAT_UPLOAD_EXTENSIONS).map(([mediaType, extension])=>[
            extension,
            mediaType
        ]),
    [
        "jpeg",
        "image/jpeg"
    ]
]);
/**
 * What this file will be attached as, or `null` if it may not be attached.
 *
 * The one place a browser `File` becomes a contract media type, so the picker,
 * the client-side refusal, the presign request and the chip icon can never
 * disagree about a file. It is a CLASSIFIER, not a check: the bytes are sniffed
 * again server-side at consume, where extension and reported MIME are both
 * merely claims.
 *
 * A browser's reported type is unreliable in both directions — a drag from some
 * file managers carries none at all, Windows Chrome calls a `.jpg` `image/jpg` —
 * so whenever it is not one of ours the extension gets the second word. A
 * zero-byte file is refused outright: it can carry no header, and presign
 * rejects a non-positive size.
 */ export function resolveChatUploadMediaType(file) {
    if (file.size <= 0) return null;
    if (isChatUploadMediaType(file.type)) return file.type;
    const extension = file.name.toLowerCase().split(".").pop() ?? "";
    return MEDIA_TYPE_BY_EXTENSION.get(extension) ?? null;
}

//# sourceMappingURL=chat-upload-media-type.js.map